import { useState } from "react";
import "@/App.css";
import { poems } from "@/data/poems";
import { PoemTile } from "@/components/PoemTile";
import { PoemOverlay } from "@/components/PoemOverlay";
import { PasswordGate } from "@/components/PasswordGate";

export default function App() {
  const [openIndex, setOpenIndex] = useState(null);

  const open = (id) => setOpenIndex(poems.findIndex((p) => p.id === id));
  const step = (n) =>
    setOpenIndex((i) => (i + n + poems.length) % poems.length);

  return (
    <PasswordGate>
      <main className="gallery-page" data-testid="poetry-gallery">
        <div className="gallery-grid">
          {poems.map((poem) => (
            <PoemTile key={poem.id} poem={poem} onOpen={open} />
          ))}
        </div>

        {openIndex !== null && (
          <PoemOverlay
            poem={poems[openIndex]}
            onClose={() => setOpenIndex(null)}
            onPrev={() => step(-1)}
            onNext={() => step(1)}
          />
        )}
      </main>
    </PasswordGate>
  );
}
